function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_14014_31387)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#6B57FF",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 27,
  rx: 13.5,
  stroke: "#6B57FF",
  strokeOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8 8.40002L11.2 14L16.8 19.6",
  stroke: "#6B57FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14014_31387"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "white"
})));

var SvgComback = function SvgComback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comback.6a5761dd.svg";
export { ForwardRef as ReactComponent };